(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["editorial-images"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
  var items = document.querySelectorAll('.fade-in-on-scroll');
  if (!items.length) return;

  // Safety timeout: show all images after 2s if observer never fires (JS fail, ad blocker, etc.)
  var safetyTimer = setTimeout(function() {
    for (var i = 0; i < items.length; i++) {
      items[i].classList.add('is-visible');
    }
  }, 2000);

  // Poll until all items visible, then clear safety timer
  var pollTimer = setInterval(function() {
    var allVisible = true;
    for (var i = 0; i < items.length; i++) {
      if (!items[i].classList.contains('is-visible')) {
        allVisible = false;
        break;
      }
    }
    if (allVisible) {
      clearTimeout(safetyTimer);
      clearInterval(pollTimer);
    }
  }, 300);

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.1 });
  for (var i = 0; i < items.length; i++) {
    observer.observe(items[i]);
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-products-penny"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('DOMContentLoaded', function () {
  var items = document.querySelectorAll('.penny-featured__item');
  if (!items.length) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    },
    { threshold: 0.1 }
  );

  items.forEach(function (item) {
    observer.observe(item);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
